export enum NotInterestedReasons {
  NOT_INTERESTED_MISMATCHED_SKILL_SET = 30,
  NOT_INTERESTED_MISMATCHED_LEVEL = 40,
  NOT_INTERESTED_PAY_RATE = 50,
  NOT_INTERESTED_LOCATION = 60,
  NOT_INTERESTED_INDUSTRY = 70,
  NOT_INTERESTED_OTHER = 90
}

export const enum Country {
  US = 1,
  Canada = 2,
  Japan = 6,
  France = 5,
  Germany = 4
}

export const enum OrderStatus {
  Inquiry = 1,
  New = 2,
  PendingApproval = 3,
  Approved = 4,
  Filled = 5,
  OnHold = 6,
  Transferred = 7,
  FilledByCompetitor = 8,
  NoSuitableTalent = 9,
  ClientCancelled = 10,
  EntryMistakeUnqualified = 11,
  FilledByClient = 12,
  PendingOnboarding = 13,
  ClientRequested = 14
}
